import React from 'react';
import PropTypes from 'prop-types';
import CartBundleGroup from '@components/cart/receipt/CartBundleGroup';

const CartBundleRenderer = ({ group, isOthersGroup, minicart }) => {
	const baseItemGroupsKeys = Object.keys(group);

	return Object.entries(group).map(([baseItemGroupKey, itemGroup], groupIndex) => (
		<CartBundleGroup
			baseItemGroupKey={baseItemGroupKey}
			itemGroup={itemGroup}
			groupIndex={groupIndex}
			numberOfBases={baseItemGroupsKeys.length}
			key={`${baseItemGroupKey}-${groupIndex}`}
			isOthersGroup={isOthersGroup}
			minicart={minicart}
		/>
	));
};

CartBundleRenderer.propTypes = {
	group: PropTypes.shape({
		[PropTypes.string]: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.string,
			})
		),
	}),
	minicart: PropTypes.bool,
};

export default CartBundleRenderer;
